import {
  NumericMenusMap,
  RefinementListLabelsMap,
  RefinementListsMap,
} from 'constants/instantsearch'
import { africanNationalities } from 'constants/nationalities/african'
import { asianNationalities } from 'constants/nationalities/asian'
import { europeanNationalities } from 'constants/nationalities/european'
import { latinAmericanNationalities } from 'constants/nationalities/latin-american'
import { middleEasternNationalities } from 'constants/nationalities/middle-eastern'
import { scandinavianNationalities } from 'constants/nationalities/scandinavian'
import { southAsianNationalities } from 'constants/nationalities/south-asian'

export const CollectionsMap = {
  affordable_art_under_1000_pounds: {
    slug: 'affordable-art-under-1000-pounds',
    initialFilterState: {
      numericMenu: {
        [NumericMenusMap.lowestAsk.attribute]: '2000:100000',
      },
    },
  },

  art_print_gift_ideas: {
    slug: 'art-print-gift-ideas',
    initialFilterState: {
      numericMenu: {
        [NumericMenusMap.lowestAsk.attribute]: '2000:100000',
      },
    },
  },

  art_related_gift_ideas: {
    slug: 'art-related-gift-ideas',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.medium.attribute]: [
          RefinementListLabelsMap.medium.collectible,
          RefinementListLabelsMap.medium.book,
        ],
      },
    },
  },

  mid_priced_art_1000_5000_pounds: {
    slug: 'mid-priced-art-1000-5000-pounds',
    initialFilterState: {
      numericMenu: {
        [NumericMenusMap.lowestAsk.attribute]: '100000:500000',
      },
    },
  },

  rare_luxury_artwork_finds: {
    slug: 'rare-luxury-artwork-finds',
    initialFilterState: {
      numericMenu: {
        [NumericMenusMap.lowestAsk.attribute]: '1000000:',
      },
    },
  },

  american_artists: {
    slug: 'american-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]: [
          RefinementListLabelsMap.nationalities.american,
        ] as string[],
      },
    },
  },

  british_irish_scottish_artists: {
    slug: 'british-irish-scottish-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]: [
          RefinementListLabelsMap.nationalities.british,
          RefinementListLabelsMap.nationalities.irish,
        ],
      },
    },
  },

  chinese_artists: {
    slug: 'chinese-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]: [
          RefinementListLabelsMap.nationalities.chinese,
        ],
      },
    },
  },

  french_artists: {
    slug: 'french-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]: [
          RefinementListLabelsMap.nationalities.french,
        ],
      },
    },
  },

  german_artists: {
    slug: 'german-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]: [
          RefinementListLabelsMap.nationalities.german,
        ],
      },
    },
  },

  italian_artists: {
    slug: 'italian-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]: [
          RefinementListLabelsMap.nationalities.italian,
        ],
      },
    },
  },

  spanish_artists: {
    slug: 'spanish-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]: [
          RefinementListLabelsMap.nationalities.spanish,
        ],
      },
    },
  },

  japanese_artists: {
    slug: 'japanese-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]: [
          RefinementListLabelsMap.nationalities.japanese,
        ],
      },
    },
  },

  asian_artists: {
    slug: 'asian-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]: asianNationalities,
      },
    },
  },

  african_artists: {
    slug: 'african-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]: africanNationalities,
      },
    },
  },

  european_artists: {
    slug: 'european-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]: europeanNationalities,
      },
    },
  },

  latin_american_artists: {
    slug: 'latin-american-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]:
          latinAmericanNationalities,
      },
    },
  },

  middle_eastern_artists: {
    slug: 'middle-eastern-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]:
          middleEasternNationalities,
      },
    },
  },

  scandinavian_artists: {
    slug: 'scandinavian-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]: scandinavianNationalities,
      },
    },
  },

  south_asian_artists: {
    slug: 'south-asian-artists',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.nationalities.attribute]: southAsianNationalities,
      },
    },
  },

  prints: {
    slug: 'prints',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.medium.attribute]: [
          RefinementListLabelsMap.medium.print,
        ] as string[],
      },
    },
  },

  sculptures: {
    slug: 'sculptures',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.medium.attribute]: [
          RefinementListLabelsMap.medium.sculpture,
        ] as string[],
      },
    },
  },

  collectibles: {
    slug: 'collectibles',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.medium.attribute]: [
          RefinementListLabelsMap.medium.collectible,
        ] as string[],
      },
    },
  },
  photography: {
    slug: 'photography',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.medium.attribute]: [
          RefinementListLabelsMap.medium.photography,
        ] as string[],
      },
    },
  },
  // original: {
  //   slug: 'original',
  //   initialFilterState: {
  //     refinementList: {
  //       [RefinementListsMap.medium.attribute]: [
  //         RefinementListLabelsMap.medium.original,
  //       ] as string[],
  //     },
  //   },
  // },

  art_books: {
    slug: 'art-books',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.medium.attribute]: [
          RefinementListLabelsMap.medium.book,
        ] as string[],
      },
    },
  },

  ceramic_art: {
    slug: 'ceramic-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.ceramic,
        ],
      },
    },
  },

  digital_art: {
    slug: 'digital-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.digital,
        ],
      },
    },
  },

  etching_art: {
    slug: 'etching-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.etching,
        ],
      },
    },
  },

  glass_art: {
    slug: 'glass-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.glass,
        ],
      },
    },
  },

  inkjet_art: {
    slug: 'inkjet-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.inkjet,
        ],
      },
    },
  },

  letterpress_art: {
    slug: 'letterpress-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.letterpress,
        ],
      },
    },
  },

  linocut_art: {
    slug: 'linocut-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.linocut,
        ],
      },
    },
  },

  lithograph_art: {
    slug: 'lithograph-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.lithograph,
        ],
      },
    },
  },

  plush_art: {
    slug: 'plush-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.plush,
        ],
      },
    },
  },

  polystone_art: {
    slug: 'polystone-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.polystone,
        ],
      },
    },
  },

  porcelain_art: {
    slug: 'porcelain-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.porcelain,
        ],
      },
    },
  },

  resin_art: {
    slug: 'resin-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.resin,
        ],
      },
    },
  },

  screenprint_art: {
    slug: 'screenprint-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.screenprint,
        ],
      },
    },
  },

  vinyl_art: {
    slug: 'vinyl-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.vinyl,
        ],
      },
    },
  },

  woodcut_art: {
    slug: 'woodcut-art',
    initialFilterState: {
      refinementList: {
        [RefinementListsMap.material.attribute]: [
          RefinementListLabelsMap.material.woodcut,
        ],
      },
    },
  },
} as const

export type Collection = keyof typeof CollectionsMap

export type CollectionsArray = readonly (typeof CollectionsMap)[Collection][]

export const NationalityCollections = [
  CollectionsMap.african_artists,
  CollectionsMap.american_artists,
  CollectionsMap.asian_artists,
  CollectionsMap.british_irish_scottish_artists,
  CollectionsMap.chinese_artists,
  CollectionsMap.european_artists,
  CollectionsMap.french_artists,
  CollectionsMap.german_artists,
  CollectionsMap.italian_artists,
  CollectionsMap.japanese_artists,
  CollectionsMap.latin_american_artists,
  CollectionsMap.middle_eastern_artists,
  CollectionsMap.scandinavian_artists,
  CollectionsMap.south_asian_artists,
  CollectionsMap.spanish_artists,
] as const

export const PriceCollections = [
  CollectionsMap.affordable_art_under_1000_pounds,
  CollectionsMap.rare_luxury_artwork_finds,
  CollectionsMap.mid_priced_art_1000_5000_pounds,
] as const

export const GiftCollections = [
  CollectionsMap.art_print_gift_ideas,
  CollectionsMap.art_related_gift_ideas,
] as const

export const MediumCollections = [
  CollectionsMap.prints,
  CollectionsMap.sculptures,
  CollectionsMap.collectibles,

  CollectionsMap.art_books,
] as const

export const MaterialCollections = [
  CollectionsMap.ceramic_art,
  CollectionsMap.digital_art,
  CollectionsMap.etching_art,
  CollectionsMap.glass_art,
  CollectionsMap.inkjet_art,
  CollectionsMap.letterpress_art,
  CollectionsMap.linocut_art,
  CollectionsMap.lithograph_art,
  CollectionsMap.plush_art,
  CollectionsMap.polystone_art,
  CollectionsMap.porcelain_art,
  CollectionsMap.resin_art,
  CollectionsMap.screenprint_art,
  CollectionsMap.vinyl_art,
  CollectionsMap.woodcut_art,
] as const
